module.exports = __webpack_public_path__ + "static/img/F01-合肥包河区协和双语学校1.1ea2549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/F01-合肥包河区协和双语学校1.png
// module id = +LRz
// module chunks = 0